import React from "react";
import { useSelector } from "react-redux";
import PageLoader from "../theme/GenericLoader/PageLoader";
import AccessDenied from "../Pages/AccessDenied/AccessDenied";
import {
  isAuthzAppAccessDenied,
  isAuthzAppType,
  isAuthzBootstrapPending,
} from "../utilities/authzPermissions";

/**
 * Blocks app content until the first /auth/me completes for UMS AuthZ apps.
 * After load: no UMS profile for this app → Access Denied (no Keycloak fallback).
 */
const AuthzBootstrapGate = ({ appType, children, onLogout }) => {
  const authzState = useSelector((state) => state.authzState);

  if (!isAuthzAppType(appType)) {
    return children;
  }

  if (isAuthzBootstrapPending(appType, authzState)) {
    return <PageLoader context="Loading permissions..." />;
  }

  if (isAuthzAppAccessDenied(appType, authzState)) {
    return <AccessDenied onLogout={onLogout} />;
  }

  return children;
};

export default AuthzBootstrapGate;
